var yellowBoards = [
  [
    ['','','-l','','','','',''],
    ['','','','','','*l_','',''],
    ['','','','','','','','*_l'],
    ['l_','','','','','','',''],
    ['','','','*_l','','','',''],
    ['','','','','','','*l-',''],
    ['','*-l','','','','','',''],
    ['','','','','','','','']
  ],
  [
    ['','','','','','l-','',''],
    ['','','*_l','','','','',''],
    ['','','','','','','',''],
    ['','*l_','','','','','',''],
    ['l_','','','','','','*l-',''],
    ['','','','','','','',''],
    ['','','','','','*-l','',''],
    ['','','','*_l','','','','']
  ],
  [
    ['','','','','l-','','',''],
    ['','','','','','','*l_',''],
    ['','','','','','','',''],
    ['','*-l','','','','','',''],
    ['','','','','','*l-','',''],
    ['','','*_l','','','','','_l'],
    ['l_','','','','','','',''],
    ['','','','','','','','']
  ]
]

var blueBoards = [
  [
    ['','','','-l','','','',''],
    ['','','','','','*_l','',''],
    ['','*l_','','','','','',''],
    ['l_','','','','','','',''],
    ['','','','*_l','','','*l-',''],
    ['','','','','','','',''],
    ['','','*-l','','','','',''],
    ['','','','','','','','']
  ],
  [
    ['','','','','','l-','',''],
    ['','','*l-','','','','',''],
    ['','','','','','','',''],
    ['','','','','','','*l_',''],
    ['l_','','','','','','',''],
    ['','','','','*-l','','',''],
    ['','*_l','','','','','',''],
    ['','','','','','','','']
  ],
  [
    ['','','','','','-l','',''],
    ['','','','','','','',''],
    ['','','','*l-','','','',''],
    ['','','','','','*l_','',''],
    ['l-','','*-l','','','','',''],
    ['','','','','*_l','','',''],
    ['','','','','','','',''],
    ['','','','','','','','']
  ]
]

var greenBoards = [
  [
    ['','-l','','','','','',''],
    ['','','','*l-','','','',''],
    ['','','','','','','',''],
    ['','','','','','','*_l',''],
    ['','*l_','','','','','',''],
    ['','','','','','','',''],
    ['l-','','','','*-l','','',''],
    ['','','','','','','','']
  ],
  [
    ['','','','','','l-','',''],
    ['','','','','','','*_l',''],
    ['','*l-','','','','','',''],
    ['','','','','','','',''],
    ['','','','','','','',''],
    ['','','','','','','*-l',''],
    ['l-','','*l_','','','','',''],
    ['','','','','','','','']
  ],
  [
    ['','-l','','','','','',''],
    ['','','','','*l-','','',''],
    ['','*-l','','','','','',''],
    ['','','','','','','*_l',''],
    ['','','','','','','',''],
    ['l_','','','','','','',''],
    ['','','','*l_','','','',''],
    ['','','','','','','','']
  ]
]

var redBoards = [
  [
    ['','-l','','','','','',''],
    ['','','','','*-l','','',''],
    ['','','','','','','',''],
    ['','*l_','','','','','',''],
    ['','','','','','','',''],
    ['','','','','','*l-','',''],
    ['l-','','','*_l','','','',''],
    ['','','','','','','','']
  ],
  [
    ['','','','-l','','','',''],
    ['','*l_','','','','','',''],
    ['','','','','','','*-l',''],
    ['','','','','','','',''],
    ['','','*_l','','','','',''],
    ['','','','','','','','*l-'],
    ['l-','','','','','','',''],
    ['','','','','','','','']
  ],
  [
    ['','','','-l','','','',''],
    ['','','','','','','',''],
    ['','','','','','*-l','',''],
    ['','','','','','','',''],
    ['l_','','*-l','','','','',''],
    ['','','','','','','','*l_'],
    ['','*l-','','','','','',''],
    ['','','','','','','','']
  ]
]

export const boardData = [yellowBoards, redBoards, greenBoards, blueBoards]


// WEBPACK FOOTER //
// ./game/BoardData.js